export default function filterCompanies(list, dark, lang) {
  const slider = [];
  for (let co = 0; co < list.length; co += 1) {
    const company = list[co];
    const hasText = company.text && company.text.item && company.document;
    const hasContent = hasText && company.text.item[lang].main_content &&
      company.logo && company.logo.$src;
    if (hasContent && ((!dark && !company.$dark) || (dark && company.$dark))) {
      slider.push(company);
    }
  }
  return slider;
}



// WEBPACK FOOTER //
// ./src/helpers/filterCompanies.js